import { useState } from "react";
import { IconButton, Popover, Typography, Box } from "@mui/material";
// import FunctionsIcon from '@mui/icons-material/Functions';
import CalculateIcon from "@mui/icons-material/Calculate";

const FormulaFinalRate = ({
  billRate,
  cashDiscount,
  discountAmount,
  finalRate,
}) => {
  const [anchorEl, setAnchorEl] = useState(null);

  const handleOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? "formula-popover" : undefined;

  const calculatedDiscountAmount = (cashDiscount / 100) * billRate; // Calculate the discount amount

  return (
    <>
      <IconButton
        size="small"
        onClick={handleOpen}
        sx={{ padding: "0 0 0 4px" }}
      >
        <CalculateIcon fontSize="inherit" />
      </IconButton>
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
      >
        <Box sx={{ p: 2}}>
          <Typography variant="body2">
            <strong>Formula:</strong>
            <br />
            Cash Discount = {Number(cashDiscount).toFixed(2)}%
            <br />
            Bill Rate = {Number(billRate).toFixed(0)}
            <br />
            <br />
            <strong>Discount Amount</strong> <br /> = (Cash Discount / 100) ×
            Bill Rate
            <br />
            <strong> </strong> = ({Number(cashDiscount).toFixed(2)} / 100) ×{" "}
            {Number(billRate).toFixed(0)}
            <br />
            <strong> </strong> = ₹{Number(calculatedDiscountAmount).toFixed(0)}
            <br />
            <br />
            <strong>Final Rate</strong>
            <br /> = ₹{Number(billRate).toFixed(0)} - ₹
            {Number(calculatedDiscountAmount).toFixed(0)}
            <br />= <strong> ₹ {Number(finalRate).toFixed(0)}/-</strong>
          </Typography>
        </Box>
      </Popover>
    </>
  );
};

export default FormulaFinalRate;
